import moment from 'moment';
import { html, LitEntity } from '../../utility/lit-entity';
import '../../common/bn-placeholder';

class DeviceTimeSinceLastEvent extends LitEntity {
  render() {
    const lastHeartbeat = this.entity && this.entity.properties.lastHeartbeat && moment(this.entity.properties.lastHeartbeat);
    if (!lastHeartbeat) {
      if (this.loading) {
        return html`<bn-placeholder></bn-placeholder>`;
      } else {
        return html``;
      }
    }

    return html`
      <span title="${lastHeartbeat && lastHeartbeat.format('MMM DD, hh:mm a')}">${lastHeartbeat.fromNow()}</span>
    `;
  }
}

window.customElements.define('device-time-since-last-event', DeviceTimeSinceLastEvent);
